import _ from 'lodash';
import { createSelector } from 'reselect';
import { getAllSettings } from '../../../../shared/selectors/app-settings';
import { MAIN_ITEM_TYPE_VALUES } from '@wix/wix-vod-constants/dist/app-settings/main-item-type-values';
export var isMainItemChannelCover = createSelector([getAllSettings], function (appSettings) {
    return _.get(appSettings, 'numbers.mainItemType') ===
        MAIN_ITEM_TYPE_VALUES.CHANNEL_COVER;
});
